module.exports = __webpack_public_path__ + "a2eafa37b563a95e8b1c0b3110c812df.png";